module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAATRJREFUOE+llMsNgkAQhlkasAS0A73wOAkVqB1oBWoHWIF2oB1IB+KJx4kSoANtAPxnAwSRXQhuQkiYmY9/XsuUnhOGYQKXwjTNhcyVyYxBEGwZY1fyKYpiZ1nWTeTfB0oB0srgRKZKCIIaG5BHUwFUOVDld6mSgXyAlq0gH6ocKSiO43me5xqC5/izDWd6uo4HnwQ+iaqqma7r1AyFoSse3qu+7vXYPYZaNAs6igd1GStTogJORlEU5Y0UbV7sP2AcQnWquzYCVkN4sZvpRFG0Rr73ISmicxvDMKhR/HyBuoZQBG0P5xcIo3BA4HmIIvgcMZyXTkUAkWE/BARFJ6yLK0rtZy0Q8OQ1aK0LfQfIFil6VfNUAtxqSal+sLkNYIrUZkJFMEwpQHT30B1VAulaWVegD6+Nld2M+Ku/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xing2.png
// module id = 9Uf6
// module chunks = 2